"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
// ----------------------------------------------------------------------
const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
function Progress(theme) {
    const rootStyle = (ownerState) => {
        const bufferVariant = ownerState.variant === 'buffer';
        const defaultStyle = {
            borderRadius: 4,
            '& .MuiLinearProgress-bar': {
                borderRadius: 4,
            },
            ...(bufferVariant && {
                backgroundColor: 'transparent',
            }),
        };
        const colorStyle = COLORS.map(color => ({
            ...(ownerState.color === color && {
                backgroundColor: (0, styles_1.alpha)(theme.palette[color].main, 0.24),
            }),
        }));
        return [...colorStyle, defaultStyle];
    };
    return {
        MuiLinearProgress: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyle(ownerState),
            },
        },
    };
}
exports.default = Progress;
